(function () {
  'use strict';

  var AUTO_SCROLL_URL =
    'https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js';
  var initialized = false;

  // Both extensions register under window.splide.Extensions (lowercase)
  function getExtensions() {
    return (window.splide && window.splide.Extensions) || undefined;
  }

  function extendDesktopList() {
    var list = document.querySelector('#claims-gallery-splide .splide__list');
    if (!list) return;
    for (var i = 0; i < 6; i++) list.innerHTML += list.innerHTML;
  }

  function mountSlider(selector, options) {
    var element = document.querySelector(selector);
    if (!element) return;

    var splide = new Splide(element, options);
    splide.on('ready', function () {
      element.classList.add('is-active');
    });
    splide.mount(getExtensions());

    new IntersectionObserver(
      function (entries) {
        var autoScroll = splide.Components.AutoScroll;
        if (!autoScroll) return;
        if (entries[0].isIntersecting) autoScroll.play();
        else autoScroll.pause();
      },
      { threshold: 0.1 }
    ).observe(element);
  }

  function initSliders() {
    if (initialized || typeof Splide !== 'function') return;
    initialized = true;

    extendDesktopList();

    mountSlider('#claims-gallery-splide', {
      perPage: 5,
      autoWidth: true,
      type: 'loop',
      pagination: false,
      direction: 'ttb',
      arrows: false,
      pauseOnHover: true,
      height: 'auto',
      drag: true,
      grid: { rows: 2, cols: 2 },
      autoScroll: { speed: 0.5, pauseOnHover: true },
    });

    mountSlider('#claims-gallery-slide-mobile', {
      perPage: 1,
      focus: 'center',
      autoWidth: true,
      pagination: false,
      arrows: false,
      type: 'loop',
      drag: true,
      gap: '16px',
      autoScroll: { speed: 0.8, pauseOnHover: false, pauseOnFocus: false },
    });
  }

  function loadAutoScrollThenInit() {
    // AutoScroll already loaded (registered under window.splide.Extensions)
    if (window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll) {
      initSliders();
      return;
    }
    var script = document.createElement('script');
    script.src = AUTO_SCROLL_URL;
    script.onload = initSliders;
    // If CDN fails, still init — Grid layout will work; auto-scroll won't
    script.onerror = initSliders;
    document.head.appendChild(script);
  }

  var section = document.querySelector('.claims-gallery-scroller');
  if (!section) return;

  // Fallback for very old browsers without IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    loadAutoScrollThenInit();
    return;
  }

  // Defer load + init until the section approaches the viewport
  new IntersectionObserver(
    function (entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      loadAutoScrollThenInit();
    },
    { rootMargin: '300px' }
  ).observe(section);
})();
